module.exports = __webpack_public_path__ + "static/media/america-atlas.1d4b5568.mp4";